import { Controller } from "@hotwired/stimulus"

// The pins as a list with folders you open, shared by the Pinned widget
// (home_widgets/_pinned) and the pin editor (home_insights/_pins_editor). A
// folder row swaps the list for that folder's pins, and the "Pins" label above
// becomes the way back: to the folder above, for a folder inside a folder,
// else to the top list. Each folder's list carries its parent's id and name
// (data-parent-id, data-back-label).
export default class extends Controller {
    static targets = ["root", "folder", "title", "back", "backLabel"]

    // The pin editor's frame, and the Pins widget's, remember which folder was
    // open across a reload (utils/refresh_pins, pin_reorder's reload), so
    // filing or renaming leaves you where you were.
    connect() {
        const open = this.element.closest("turbo-frame")?.dataset.openFolder
        if (open) this._show(open)
    }

    open(event) {
        event.preventDefault()
        this._show(String(event.params.folder))
    }

    back(event) {
        event?.preventDefault()
        const current = this.folderTargets.find((list) => !list.hidden)
        const parent = current?.dataset.parentId
        if (parent) this._show(parent)
        else this._showRoot()
    }

    _show(id) {
        const folder = this.folderTargets.find((list) => list.dataset.folderId === id)
        if (!folder) return
        this.rootTarget.hidden = true
        this.folderTargets.forEach((list) => { list.hidden = list !== folder })
        if (this.hasTitleTarget) this.titleTarget.hidden = true
        if (this.hasBackTarget) {
            this.backTarget.hidden = false
            // Where a pin dragged onto "‹" goes: the level above this one.
            this.backTarget.dataset.pinDropInto = folder.dataset.parentId || "root"
        }
        if (this.hasBackLabelTarget) this.backLabelTarget.textContent = folder.dataset.backLabel || "Pins"
        this.element.closest(".home-widget-body")?.scrollTo?.({ top: 0 })
    }

    _showRoot() {
        this.folderTargets.forEach((list) => { list.hidden = true })
        this.rootTarget.hidden = false
        if (this.hasTitleTarget) this.titleTarget.hidden = false
        if (this.hasBackTarget) this.backTarget.hidden = true
    }
}
